import {
  ChatHistoryRequest,
  ChatHistoryResponse,
  ChatRequest,
  ChatJobInitResponse,
  ChatJobStatusResponse,
  SessionDeactivationRequest,
  SessionDeactivationResponse,
} from "Interfaces/interface.chat";
import aiInterceptor from "../interceptors/aiInterceptor";

const chatService = {
  startChatJob: async (data: ChatRequest): Promise<ChatJobInitResponse> => {
    try {
      const response = await aiInterceptor.post<ChatJobInitResponse>(
        "/chat",
        data,
      );
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        error.message ||
        "Failed to enqueue chat job";
      throw new Error(`startChatJob error: ${message}`);
    }
  },

  getJobStatus: async (jobId: string): Promise<ChatJobStatusResponse> => {
    try {
      const response = await aiInterceptor.get<ChatJobStatusResponse>(
        `/chat/status/${jobId}`,
      );
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        error.message ||
        "Failed to fetch chat job status";
      throw {
        ...error,
        message: `getJobStatus error: ${message}`,
      };
    }
  },

  getChatHistory: async (
    params: ChatHistoryRequest,
  ): Promise<ChatHistoryResponse> => {
    try {
      const response = await aiInterceptor.get<ChatHistoryResponse>(
        "/chat/history",
        { params },
      );
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        error.message ||
        "Failed to fetch chat history";
      throw new Error(`getChatHistory error: ${message}`);
    }
  },

  deactivateSession: async (
    request: SessionDeactivationRequest,
  ): Promise<SessionDeactivationResponse> => {
    console.log("aiInterceptor: ", aiInterceptor);
    const response = await aiInterceptor.post<SessionDeactivationResponse>(
      "/chat/session/deactivate",
      request,
    );
    return response.data;
  },

  uploadAudio: async (
    audioFile: File | Blob,
    userId: string,
    sessionId?: string,
  ): Promise<any> => {
    try {
      const formData = new FormData();
      formData.append("audio", audioFile);
      if (sessionId) {
        formData.append("sessionId", sessionId);
      }
      formData.append("userId", userId);

      const response = await aiInterceptor.post("/att", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.detail ||
        error.message ||
        "Failed to upload audio";
      throw new Error(`uploadAudio error: ${message}`);
    }
  },
};

export default chatService;
